// Cash Transactions Vuex

import state from './cashTransactionStates.js'
import * as getters from './cashTransactionGetters.js'
import * as mutations from './cashTransactionMutations.js'
import * as actions from './cashTransactionActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
